import t from '@/i18n';
const one_day = 1000 * 60 * 60 * 24;

const daysLeft = (dateString, period = [0, Infinity]) => {
  let daysLeft = t('days left');
  let today = new Date();
  let date = new Date(dateString);
  let days = Math.ceil((date.getTime() - today.getTime()) / one_day);
  if (days < period[1] && days > period[0]) {
    return `${days} ${daysLeft}`;
  } else return null;
};

export default daysLeft;
